var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var FlagGb16 = function FlagGb16(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
    fill: "#D8DDE1"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.253 12.813h4.397L9.253 9.716v3.097zM.5 9.349v2.155c0 .083.008.163.022.24l3.36-2.339L.5 9.35zm.023-5.782c-.015.08-.023.16-.023.242v2.049l3.355.056L.523 3.567zM13.794 2.5H9.253v3.163L13.794 2.5zM15.5 5.858V3.809c0-.083-.008-.164-.023-.242l-3.332 2.347 3.355-.056zm-.023 5.887c.014-.078.023-.158.023-.24V9.348l-3.381.056 3.359 2.34zM6.747 2.5H2.206l4.54 3.163V2.501zM2.35 12.813h4.397V9.716L2.35 12.813",
    fill: "#1A3179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.747 5.663 2.206 2.5h-.431c-.27 0-.535.089-.752.254l4.47 3.207h-1.12L.623 3.249c-.046.1-.08.207-.1.317l3.332 2.347L.5 5.857v.698l4.363.068 2.385.036V2.5h-.501v3.163zm2.005 3.091v4.058h.501V9.715l4.397 3.097h.575c.308 0 .59-.113.811-.3l-4.53-3.06h1.121l3.782 2.533c.03-.078.053-.159.069-.241l-3.36-2.34 3.382-.056V8.65l-4.368.067-2.38.037zM.5 8.65v.698l3.381.057-3.359 2.339c.055.301.211.573.442.769l4.53-3.06h1.12l-4.823 3.359h.559l4.397-3.097v3.097h.501V8.754l-2.38-.037L.5 8.65zm11.645-2.737 3.332-2.347a1.312 1.312 0 0 0-.5-.812l-4.47 3.207H9.385l4.825-3.46h-.416L9.253 5.662V2.5h-.501v4.16l2.385-.037 4.363-.068v-.698l-3.355.056",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.137 6.623-2.385.036V2.5H7.248v4.16l-2.385-.037L.5 6.555V8.65l4.368.067 2.38.037v4.058h1.504V8.754l2.38-.037L15.5 8.65V6.555l-4.363.068",
    fill: "#FF2B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.372 5.961h1.12l-4.47-3.207a1.306 1.306 0 0 0-.4.495l3.75 2.712zm5.012 0h1.121l4.471-3.207a1.247 1.247 0 0 0-.752-.254h-.015L9.384 5.961zm1.121 3.492 4.53 3.06a1.31 1.31 0 0 0 .373-.528l-3.782-2.532h-1.12zm-5.013 0-4.53 3.06c.229.193.516.3.812.299h.016l4.823-3.36h-1.12",
    fill: "#FF2B2D"
  })));
};

FlagGb16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '16': FlagGb16
};
export var FlagGb = function FlagGb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '16' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['16'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'FlagGb' icon. Please use one of the available sizes: '16'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};